import { render } from "./linkCollection.vue?vue&type=template&id=2117f75f&scoped=true"
const script = {}

import "./linkCollection.vue?vue&type=style&index=0&id=2117f75f&scoped=true&lang=css"

import exportComponent from "/home/tyamada/ckan-ext-dev/yamanashi-dataplatform-admin-system-main/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2117f75f"]])

export default __exports__